module.exports = __webpack_public_path__ + "fonts/IstokWeb-BoldItalic.92c1a332.woff";